/** Mirrors ApiConfig defaults so asset URLs stay consistent with the API client base URL. */
function configuredApiBase(): string {
  const fromEnv = import.meta.env.VITE_API_BASE_URL;
  if (fromEnv) return fromEnv;
  const mode = import.meta.env.MODE || 'development';
  if (mode === 'development') return '/api';
  if (mode === 'staging') return 'https://api.saung.axra.com.mm';
  return 'https://api.saung.axra.com.mm';
}

function apiOriginFromBase(apiBase: string): string | undefined {
  try {
    if (/^https?:\/\//i.test(apiBase)) {
      const api = new URL(apiBase);
      return `${api.protocol}//${api.host}`;
    }
    // Relative base (e.g. dev proxy `/api`): resolve assets against the app origin
    if (typeof window !== 'undefined' && apiBase.startsWith('/')) {
      return window.location.origin;
    }
  } catch {
    /* ignore */
  }
  return undefined;
}

/**
 * Resolve a potentially relative asset URL to an absolute URL that the browser can fetch.
 * - If the input is already an absolute URL (http/https), it is returned as-is.
 * - If it starts with '/', it will be resolved against the API server origin
 *   derived from the configured API base URL (without the path, e.g., /api).
 * - Otherwise, it is returned unchanged.
 */
export function resolveAssetUrl(input: string | null | undefined): string | undefined {
  if (!input) return undefined;
  const url = String(input).trim();
  if (!url) return undefined;

  // Already absolute
  if (/^https?:\/\//i.test(url)) return url;

  const apiBase = configuredApiBase();
  const origin = apiOriginFromBase(apiBase);
  if (!origin) return url;

  if (url.startsWith('/')) {
    return origin + url;
  }

  return `${origin}/${url}`;
}


